import type { ReactNode } from 'react';

import Heading from '../../../../../common/components/Heading';

const ProductDetailHeading = (props: { children: ReactNode }) => (
    <Heading
        stylingElement="h5"
        element="h3"
        className="u-marginBxxsm u-textWeightBold u-wordBreakAll"
        alignment="start"
    >
        {props.children}
    </Heading>
);

export default ProductDetailHeading;
